import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SectionGroup, Section } from 'bricks';
import { getPreorderContent, getPreorderHeadline } from 'store/ProductDetails/preorder/selectors';

import TabRouterLayout from '../_TabLayout';

function PreorderTab({ headline, children }) {
  return (
    <TabRouterLayout>
      <SectionGroup>
        <Section title={headline}>{children}</Section>
      </SectionGroup>
    </TabRouterLayout>
  );
}

PreorderTab.propTypes = {
  headline: PropTypes.node,
  children: PropTypes.node,
};

const mapStateToProps = (state) => ({
  headline: getPreorderHeadline(state),
  children: getPreorderContent(state),
});

export default connect(mapStateToProps)(PreorderTab);
